/**
 * Türkçe metin normalleştirme — paylaşılan alfabe kıvrımı.
 *
 * Sunucu (adres → sokak eşleme) ve panel (mahalle/sokak arama + bölge eşleme) aynı kuralla
 * karşılaştırma yapar. Tekilleştirilmiş boşluk + Türkçe locale küçük harf + ASCII kıvrım
 * (ı→i ş→s ç→c ö→o ü→u ğ→g). Bu üç adım BİRLİKTE uygulanmazsa "Çıkınlar" araması
 * "cikin" ya da "sümer" araması "SÜMER" tutmaz.
 *
 * `toLocaleLowerCase('tr-TR')` ile büyük `İ` küçük `i`, büyük `I` da küçük `ı` olur; ASCII
 * kıvrımı yalnız `ı`/`i` farkını giderir, böylece arama terimi de aynı yola sokulmuş olur.
 */
export function foldTurkish(s: string): string {
  return s
    .trim()
    .replace(/\s+/g, ' ')
    .toLocaleLowerCase('tr-TR')
    .replace(/[ışçöüğ]/g, (c) => FOLD_MAP[c] ?? c);
}

const FOLD_MAP: Record<string, string> = {
  ı: 'i',
  ş: 's',
  ç: 'c',
  ö: 'o',
  ü: 'u',
  ğ: 'g',
};

/**
 * Mahalle karşılaştırma anahtarı: önce Türkçe katlama, SONRA sondaki "Mah/Mahalle/Mahallesi/Mh"
 * eki atılır ("SÜMER MAHALLESİ" → "sumer"). API (mahalle→bölge) ve panel (harita) AYNI anahtarı
 * kullanır; ikisi ayrışırsa harita ile sunucunun bölge kararı farklı olur.
 */
export function neighborhoodKey(name: string): string {
  return foldTurkish(name)
    .replace(/\s+(?:mahallesi|mahalle|mah|mh)\.?$/u, '')
    .trim();
}
